// Spec §2.7a — Order module's "Тохиргоо" (8th menu) sub-items 1-9.
// Item 6 (Хүргэлтийн Policy) bundles 4 brainstorm-decision sub-sections via
// accordion in GovernanceConfigTab; items 7/8/9 are separate top-level tabs.

import { Tabs } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { ChannelLabelsTab } from "./ChannelLabelsTab"
import { ClassificationRuleTab } from "./ClassificationRuleTab"
import { CodConfigTab } from "./CodConfigTab"
import { ConsolidationRuleTab } from "./ConsolidationRuleTab"
import { GovernanceConfigTab } from "./GovernanceConfigTab"
import { HolidayCalendarTab } from "./HolidayCalendarTab"
import { InboundFlowTab } from "./InboundFlowTab"
import { NotificationTemplateTab } from "./NotificationTemplateTab"
import { SizeScaleTab } from "./SizeScaleTab"

export function Settings() {
  const { t } = useTranslation("settings")
  return (
    // The 9 tabs wrap onto a second line instead of scrolling out of view (O36).
    <Tabs defaultValue="size-scale" keepMounted={false} styles={{ list: { flexWrap: "nowrap", overflowX: "auto" }, tab: { paddingInline: "var(--mantine-spacing-sm)", whiteSpace: "nowrap" } }}>
      <Tabs.List>
        <>
          {/* §2.7a item 1 */}
          <Tabs.Tab value="size-scale">
            {t("page.tabs.sizeScale")}
          </Tabs.Tab>
          {/* §2.7a item 2 */}
          <Tabs.Tab value="classification">
            {t("page.tabs.classification")}
          </Tabs.Tab>
          {/* §2.7a item 3 */}
          <Tabs.Tab value="consolidation">
            {t("page.tabs.consolidation")}
          </Tabs.Tab>
          {/* §2.7a item 4 — Holidays + Working schedule (workingDays/Hours/cutoff) */}
          <Tabs.Tab value="holidays">
            {t("page.tabs.holidays")}
          </Tabs.Tab>
          {/* §2.7a item 5 */}
          <Tabs.Tab value="notification">
            {t("page.tabs.notification")}
          </Tabs.Tab>
          {/* §2.7a item 6 — Хүргэлтийн Policy (Q8/Q9/Q11/Q13 + Role Mapping) */}
          <Tabs.Tab value="governance">
            {t("page.tabs.governance")}
          </Tabs.Tab>
          {/* §2.7a item 7 — config + reconciliation (nested Tabs in CodConfigTab) */}
          <Tabs.Tab value="cod">
            {t("page.tabs.cod")}
          </Tabs.Tab>
          {/* §2.7a item 8 — B13 */}
          <Tabs.Tab value="channel-labels">
            {t("page.tabs.channelLabels")}
          </Tabs.Tab>
          {/* §2.7a item 9 — B13 */}
          <Tabs.Tab value="inbound">
            {t("page.tabs.inbound")}
          </Tabs.Tab>
        </>
      </Tabs.List>

      <Tabs.Panel value="size-scale" pt="md">
        <SizeScaleTab />
      </Tabs.Panel>
      <Tabs.Panel value="classification" pt="md">
        <ClassificationRuleTab />
      </Tabs.Panel>
      <Tabs.Panel value="consolidation" pt="md">
        <ConsolidationRuleTab />
      </Tabs.Panel>
      <Tabs.Panel value="holidays" pt="md">
        <HolidayCalendarTab />
      </Tabs.Panel>
      <Tabs.Panel value="notification" pt="md">
        <NotificationTemplateTab />
      </Tabs.Panel>
      <Tabs.Panel value="governance" pt="md">
        <GovernanceConfigTab />
      </Tabs.Panel>
      <Tabs.Panel value="cod" pt="md">
        <CodConfigTab />
      </Tabs.Panel>
      <Tabs.Panel value="channel-labels" pt="md">
        <ChannelLabelsTab />
      </Tabs.Panel>
      <Tabs.Panel value="inbound" pt="md">
        <InboundFlowTab />
      </Tabs.Panel>
    </Tabs>
  )
}
